import "./Communities.module.css";
import Navigation from "@/reusable_sections/Header";
import WhereYouBelong from "./sections/WhereYouBelong";
import LocalNeighborhoodInsights from "./sections/LocalNeighborhoodInsights";
import FindYourFit from "./sections/FindYourFit";
import FooterInformation from "@/reusable_sections/Footer";
export default function CommunitiesPage() {
  return <div>
      <Navigation />
      <WhereYouBelong />
      <LocalNeighborhoodInsights />
      <FindYourFit />
      <FooterInformation />
    </div>;
}